import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { MasterlocationRepository } from "../../repositories/master-location.repository";
import { Filter } from "../../domain/models/filter";

@Injectable({ providedIn: 'root' })
export class GetFiltersUsecase implements UseCase<null, Filter[]> {

  constructor(private readonly masterlocationRepository: MasterlocationRepository) {
  }

  execute(): Observable<Filter[]> {
    return this.masterlocationRepository.getFilters();
  }

}